import { Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserStore } from '@store/app.store';
import { useStyledToast } from '@util/hooks';
import FullPageLoader from '@components/general/loader/full-page-loader.component';

import { useRingCentralOauth } from '@services/query-services/lambda.query-service';

function RingCentralCallbackPage() {
  const navigate = useNavigate();
  const toast = useStyledToast();
  const user = useUserStore((state) => state.user);

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const code = params.get('code');

  const { mutateAsync: ringCentralOauth } = useRingCentralOauth();

  async function authorize(code) {
    const tenantId = user.tenants[0].id;
    await ringCentralOauth(
      { code, tenantId },
      {
        onSuccess: () => toast({ title: 'RingCentral connected successfully.', status: 'success' }),
        onError: () =>
          toast({
            status: 'error',
            title: 'Something went wrong. You might already have RingCentral connected.'
          })
      }
    );

    navigate('/agenda');
  }

  useEffect(() => {
    if (code && user) authorize(code);
  }, [code, user]);

  return (
    <FullPageLoader>
      <Text>Connecting Your RingCentral Account...</Text>
    </FullPageLoader>
  );
}

export default RingCentralCallbackPage;
